// ============================================
// STOREFRONT ROUTES (audit C-04)
// ============================================
// Every fetch in this file goes through these. Hardcoded "/cart/add.js" and
// friends post to the wrong origin path the moment a market or locale prefix
// exists (/en-ca/, /fr/) — the theme's <form> tags were already using
// routes.cart_add_url, so only the JavaScript was out of step.
// layout/theme.liquid publishes window.theme.routes; the fallbacks below only
// apply if that object is ever missing.
var EvayaRoutes = (function () {
  function r(name, fallback) {
    var t = (window.theme && window.theme.routes) || {};
    return t[name] || fallback;
  }
  function root() {
    var v = r("root_url", "/");
    return v.charAt(v.length - 1) === "/" ? v : v + "/";
  }
  return {
    root: root,
    cart: function () { return r("cart_url", "/cart"); },
    cartAddJs: function () { return r("cart_add_url", "/cart/add") + ".js"; },
    cartChangeJs: function () { return r("cart_change_url", "/cart/change") + ".js"; },
    cartClearJs: function () { return root() + "cart/clear.js"; },
    discount: function (code) { return root() + "discount/" + (code ? encodeURIComponent(code) : ""); },
    section: function (id) { return root() + "?section_id=" + id; },
    cartSection: function (id) { return r("cart_url", "/cart") + "?section_id=" + id; }
  };
})();

// ============================================
// PDP — variant selection, sticky bar, thumbnail image swap
// ============================================
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.section-pdp-main, .section-envy-order').forEach(function (section) {
    var inner = section.querySelector('.pdp, .envy-pdp');
    var sectionId = inner && inner.id.replace('pdp-section-', '');
    if (!sectionId) return;

    var form = document.getElementById('product-form-' + sectionId);
    if (!form) return;

    var variantIdInput = document.getElementById('selectedVariantId-' + sectionId);
    var variantsJsonEl = document.getElementById('pdpVariantsJson-' + sectionId);
    var priceCurrentEl = document.getElementById('priceCurrent-' + sectionId);
    var priceCompareEl = document.getElementById('priceCompare-' + sectionId);
    var priceSaveEl = document.getElementById('priceSave-' + sectionId);
    var ctaPriceEl = document.getElementById('ctaPrice-' + sectionId);
    var stickyPriceEl = document.getElementById('stickyPrice-' + sectionId);
    var stickyConfigEl = document.getElementById('stickyConfig-' + sectionId);
    var heroImgEl = document.getElementById('heroImg-' + sectionId);
    var stickyBar = document.getElementById('stickyBar-' + sectionId);
    var heroShot = document.getElementById('heroShot-' + sectionId);

    var variants = [];
    try {
      variants = JSON.parse(variantsJsonEl.textContent);
    } catch (e) {
      console.error('Could not parse variants JSON', e);
    }

    // M-06: format through the shop's own money_format instead of a hardcoded
    // '$' + en-US. The old version forced maximumFractionDigits: 0, so a
    // $1,299.50 variant displayed as $1,300 and then charged $1,299.50 at
    // checkout. Whole dollars still render without ".00", matching Shopify's
    // money_without_trailing_zeros, but cents are no longer thrown away.
    //
    // NOTE: this file is .liquid, so a money-format template typed as a JS
    // literal would have its amount token evaluated away at render time. The
    // fallback below is therefore rendered FROM Liquid.
    var MONEY_FORMAT_FALLBACK = null;
    var MONEY_TOKEN = /\{\{\s*(\w+)\s*\}\}/;

    function groupAmount(cents, decimals, thousands, decimalMark) {
      var parts = (cents / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimalMark);
    }

    function formatMoney(cents) {
      var fmt = (window.theme && theme.settings && theme.settings.money_with_currency_format) || MONEY_FORMAT_FALLBACK || '';
      // The sign belongs outside the whole formatted string, not next to the
      // digits — otherwise a negative renders as "$-500" instead of "-$500".
      var negative = cents < 0;
      cents = Math.abs(cents);
      var hasCents = Math.round(cents) % 100 !== 0;
      var out;
      if (!MONEY_TOKEN.test(fmt)) {
        out = (fmt || '$') + groupAmount(cents, hasCents ? 2 : 0, ',', '.');
        return negative ? '-' + out : out;
      }
      out = fmt.replace(MONEY_TOKEN, function (_match, token) {
        switch (token) {
          case 'amount_no_decimals':                      return groupAmount(cents, 0, ',', '.');
          case 'amount_with_comma_separator':             return groupAmount(cents, hasCents ? 2 : 0, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return groupAmount(cents, 0, '.', ',');
          case 'amount_with_apostrophe_separator':        return groupAmount(cents, hasCents ? 2 : 0, "'", '.');
          case 'amount_no_decimals_with_space_separator': return groupAmount(cents, 0, ' ', '.');
          case 'amount_with_space_separator':             return groupAmount(cents, hasCents ? 2 : 0, ' ', ',');
          default:                                        return groupAmount(cents, hasCents ? 2 : 0, ',', '.');
        }
      });
      return negative ? '-' + out : out;
    }

    // LABOR DAY 2026 PROMO - White Glove is free Sep 2 20:00 ET through Sun Sep 13 23:59 ET.
    // While the promo runs, the +$199 install variants DISPLAY at the same price as
    // their free-shipping counterpart; the actual $199 comes off via the automatic
    // Shopify discount at checkout. This is display only - variant.id, the form value
    // and everything sent to the cart are untouched.
    // The window is checked against the shopper's clock rather than baked in by Liquid
    // so a CDN-cached copy of this asset cannot get stuck on the wrong side of it.
    // Self-expiring: after LDW_END, ldwPrice() returns variant.price unchanged.
    //
    // 2026-10-08: no longer date-gated. Free White Glove is now permanent per product,
    // decided in Liquid (wg_free_handles in pdp-main / pdp-buybox) and handed to this
    // script as a data-free-wg attribute on the .pdp element. The $199 comes off at
    // checkout via automatic discount DiscountAutomaticNode/1692170289445.
    var FREE_WG = !!(inner && inner.hasAttribute('data-free-wg'));
    function ldwActive() {
      return FREE_WG;
    }
    function ldwIsWhiteGlove(v) {
      if (!v) return false;
      var hay = ((v.title || '') + ' ' + ((v.options || []).join(' '))).toLowerCase();
      return hay.indexOf('install') > -1 || hay.indexOf('removal') > -1;
    }
    function ldwPrice(v) {
      if (!v || typeof v.price !== 'number') return v ? v.price : 0;
      if (ldwActive() && ldwIsWhiteGlove(v)) {
        var p = v.price - 19900;
        if (p > 0) return p;
      }
      return v.price;
    }
    // Install variants carry compare-at = free price + $199, so flatten it alongside
    // the price or the "was" figure and "Save" amount overstate the discount by $199.
    function ldwCompare(v) {
      if (!v || !v.compare_at_price) return v ? v.compare_at_price : null;
      if (ldwActive() && ldwIsWhiteGlove(v)) {
        var c = v.compare_at_price - 19900;
        if (c > 0) return c;
      }
      return v.compare_at_price;
    }

    // Promo companion to ldwPrice: the SHIPPING header label is rewritten on every
    // option click, so without this it would snap back to the raw "(+$199)" value.
    // Outside the promo window this returns the value unchanged.
    function ldwShipLabel(val) {
      var v = String(val == null ? '' : val);
      if (ldwActive() && /install|removal/i.test(v)) {
        return v.split(' (+$')[0] + ' (<s style="opacity:.45;font-weight:400">$199</s> FREE)';
      }
      return v;
    }

    function getCurrentOptions() {
      // Collect the active value for each option (from .pdp-option-btn.active or .pdp-option-input)
      var optionValues = [];
      var activeBtns = section.querySelectorAll('.pdp-option-btn.active');
      activeBtns.forEach(function (btn) {
        var idx = parseInt(btn.dataset.optionIndex, 10);
        optionValues[idx] = btn.dataset.value;
      });
      section.querySelectorAll('.pdp-option-input').forEach(function (input) {
        var idx = parseInt(input.dataset.optionIndex, 10);
        if (optionValues[idx] === undefined) {
          optionValues[idx] = input.value;
        }
      });
      return optionValues;
    }

    // H-07: every option must be chosen AND match. The old version treated an
    // unselected option as a wildcard, so it fell through to the first variant
    // matching only the options already picked — the shape that produced the
    // Bliss Full pricing bug, where the price on screen and the variant id in
    // the form drift apart. Returns null when nothing matches; the caller
    // disables the CTA rather than silently selling variant #1.
    function findMatchingVariant(optionValues) {
      if (!variants.length) return null;
      var expected = variants[0].options.length;
      for (var i = 0; i < expected; i++) {
        var chosen = optionValues[i];
        if (chosen === undefined || chosen === null || chosen === '') return null;
      }
      return variants.find(function (v) {
        return v.options.length === expected && v.options.every(function (val, i) {
          return optionValues[i] === val;
        });
      }) || null;
    }

    function updateUI(variant, isUserChange) {
      if (!variant) {
        // H-07: no complete, valid combination is selected. Lock the CTA rather
        // than leaving a stale price beside a stale variant id.
        var noMatchBtn = document.getElementById('addBtn-' + sectionId);
        if (noMatchBtn) {
          noMatchBtn.disabled = true;
          var noMatchLabel = noMatchBtn.querySelector('span:first-child');
          if (noMatchLabel) noMatchLabel.textContent = 'Unavailable · ';
        }
        return;
      }

      // Update form variant id
      if (variantIdInput) variantIdInput.value = variant.id;

      // Update prices (see ldwPrice above - Labor Day promo flattens White Glove)
      var displayPrice = ldwPrice(variant);
      if (priceCurrentEl) priceCurrentEl.textContent = formatMoney(displayPrice);
      if (ctaPriceEl) ctaPriceEl.textContent = formatMoney(displayPrice);
      if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(displayPrice);

      // Compare-at price
      if (priceCompareEl) {
        var displayCompare = ldwCompare(variant);
        if (displayCompare && displayCompare > displayPrice) {
          priceCompareEl.textContent = formatMoney(displayCompare);
          priceCompareEl.style.display = '';
          if (priceSaveEl) {
            priceSaveEl.textContent = 'Save ' + formatMoney(displayCompare - displayPrice);
            priceSaveEl.style.display = '';
          }
        } else {
          priceCompareEl.style.display = 'none';
          if (priceSaveEl) priceSaveEl.style.display = 'none';
        }
      }

      // Update opt-value displays
      var sizeValEl = document.getElementById('optValue-size-' + sectionId);
      var firmValEl = document.getElementById('optValue-firm-' + sectionId);
      var strapValEl = document.getElementById('optValue-strap-' + sectionId);
      var shippingValEl = document.getElementById('optValue-shipping-' + sectionId);
      var optNames = (variant.options || []);

      section.querySelectorAll('.pdp-option-btn.active').forEach(function (btn) {
        var idx = parseInt(btn.dataset.optionIndex, 10);
        var val = btn.dataset.value;
        if (btn.classList.contains('size') && sizeValEl) sizeValEl.textContent = val;
        if (btn.classList.contains('firm') && firmValEl) firmValEl.textContent = val;
        if (btn.classList.contains('strap') && strapValEl) strapValEl.textContent = val;
        if (btn.classList.contains('ship-card') && shippingValEl) shippingValEl.innerHTML = ldwShipLabel(val);
      });

      // Sticky bar config text
      if (stickyConfigEl) {
        var configParts = [];
        section.querySelectorAll('.size.pdp-option-btn.active, .firm.pdp-option-btn.active').forEach(function (btn) {
          configParts.push(btn.dataset.value);
        });
        if (configParts.length) stickyConfigEl.textContent = configParts.join(' · ');
      }

      // Update URL with variant param (Shopify convention). Only on a real user
      // change — doing it during the initial seed below would append ?variant=
      // to every PDP URL on load.
      if (isUserChange) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) { /* noop */ }
      }

      // Update CTA button if variant is unavailable
      var addBtn = document.getElementById('addBtn-' + sectionId);
      if (addBtn) {
        if (variant.available) {
          addBtn.disabled = false;
          addBtn.querySelector('span:first-child').textContent = 'Add to Bag · ';
        } else {
          addBtn.disabled = true;
          addBtn.querySelector('span:first-child').textContent = 'Sold out · ';
        }
      }
    }

    // Click handlers for option buttons
    section.querySelectorAll('.pdp-option-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var groupSelector;
        if (btn.classList.contains('size')) groupSelector = '.size.pdp-option-btn';
        else if (btn.classList.contains('firm')) groupSelector = '.firm.pdp-option-btn';
        else if (btn.classList.contains('strap')) groupSelector = '.strap.pdp-option-btn';
        else if (btn.classList.contains('ship-card')) groupSelector = '.ship-card.pdp-option-btn';
        else groupSelector = '.pdp-option-btn[data-option-index="' + btn.dataset.optionIndex + '"]';

        section.querySelectorAll(groupSelector).forEach(function (sibling) {
          sibling.classList.remove('active');
        });
        btn.classList.add('active');

        var currentOpts = getCurrentOptions();
        var variant = findMatchingVariant(currentOpts);
        updateUI(variant, true);
      });
    });

    // H-07 support: seed a COMPLETE selection on load, so no option is ever
    // undefined and the stricter matcher above cannot lock the CTA on a PDP the
    // merchant built without a default for every group. Prefers ?variant=, then
    // whatever the markup already marked active, then the first available.
    (function seedSelection() {
      if (!variants.length) return;
      var seeded = null;
      try {
        var wanted = new URLSearchParams(window.location.search).get('variant');
        if (wanted) {
          seeded = variants.filter(function (v) { return String(v.id) === String(wanted); })[0] || null;
        }
      } catch (e) { /* noop */ }

      if (!seeded) {
        var partial = getCurrentOptions();
        seeded = variants.filter(function (v) {
          return v.options.every(function (val, i) {
            return partial[i] === undefined || partial[i] === val;
          });
        })[0] || null;
      }
      if (!seeded) seeded = variants.filter(function (v) { return v.available; })[0] || variants[0];
      if (!seeded) return;

      seeded.options.forEach(function (val, i) {
        section.querySelectorAll('.pdp-option-btn[data-option-index="' + i + '"]').forEach(function (b) {
          if (b.dataset.value === val) b.classList.add('active');
          else b.classList.remove('active');
        });
        section.querySelectorAll('.pdp-option-input[data-option-index="' + i + '"]').forEach(function (inp) {
          inp.value = val;
        });
      });
      updateUI(seeded, false);
    })();

    // Thumbnail clicks - swap hero image
    section.querySelectorAll('.thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        section.querySelectorAll('.thumb').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        var img = thumb.querySelector('img');
        if (img && heroImgEl) {
          heroImgEl.src = img.src.replace(/_200x/g, '_1600x').replace(/width=200/g, 'width=1600');
        }
      });
    });

    // Sticky bar show/hide on scroll
    if (stickyBar && heroShot) {
      window.addEventListener('scroll', function () {
        var rect = heroShot.getBoundingClientRect();
        if (rect.bottom < 40) {
          stickyBar.classList.add('visible');
        } else {
          stickyBar.classList.remove('visible');
        }
      }, { passive: true });

      // Sticky CTA - submit the form
      var stickyCta = stickyBar.querySelector('.sticky-cta');
      if (stickyCta) {
        stickyCta.addEventListener('click', function () {
          form.requestSubmit ? form.requestSubmit() : form.submit();
        });
      }
    }
  });
});

// ============================================
// PDP — placeholder firmness selector (visual only, no variant change)
// ============================================
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pdp-firm-placeholder').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('.firm-grid');
      if (!group) return;
      group.querySelectorAll('.pdp-firm-placeholder').forEach(function (sib) {
        sib.classList.remove('active');
      });
      btn.classList.add('active');
      var label = btn.dataset.label || btn.querySelector('.firm-name').textContent;
      var section = btn.closest('.section-pdp-main');
      if (section) {
        var valEl = section.querySelector('[id^="optValue-firm-placeholder-"]');
        if (valEl) valEl.textContent = label;
      }
    });
  });
});

// ============================================
// PDP — Anatomy layer accordion (single-open behaviour)
// ============================================
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.section-pdp-anatomy .layer-stack').forEach(function (stack) {
    stack.querySelectorAll('.layer').forEach(function (layer) {
      layer.addEventListener('click', function () {
        var wasOpen = layer.classList.contains('open');
        stack.querySelectorAll('.layer.open').forEach(function (other) {
          other.classList.remove('open');
        });
        if (!wasOpen) {
          layer.classList.add('open');
        }
      });
    });
  });
});

// ============================================
// PDP — FAQ accordion (multi-open allowed)
// ============================================
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.section-pdp-faq .faq-list').forEach(function (list) {
    list.querySelectorAll('.faq-q').forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.closest('.faq-item');
        if (item) item.classList.toggle('open');
      });
    });
  });
});

// ============================================
// Reveal-on-scroll (used by PDP sections and others)
// ============================================
document.addEventListener('DOMContentLoaded', function () {
  if (!('IntersectionObserver' in window)) {
    // No IO support — just show everything
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('visible'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
});

// ============================================
// PLP — filter sidebar, sort, view toggle, price slider, chips
// ============================================
document.addEventListener('DOMContentLoaded', function () {
  var section = document.querySelector('.section-plp-shop');
  if (!section) return;

  var grid = section.querySelector('.plp-grid');
  var cards = Array.from(grid ? grid.querySelectorAll('.plp-pcard') : []);
  var countEl = section.querySelector('[data-plp-count]');
  var sortEl = section.querySelector('[data-plp-sort]');
  var chipsEl = section.querySelector('[data-plp-active-chips]');
  var emptyEl = section.querySelector('[data-plp-empty]');

  var state = {};
  // Initialise filter state buckets from data-plp-filter attributes on checkboxes
  section.querySelectorAll('[data-plp-filter]').forEach(function (cb) {
    var key = cb.dataset.plpFilter;
    state[key] = state[key] || new Set();
  });
  state.priceLow = null;
  state.priceHigh = null;

  function applyFilters() {
    var visible = 0;
    cards.forEach(function (card) {
      var ok = true;

      // Firmness
      if (state.firmness && state.firmness.size) {
        ok = ok && state.firmness.has((card.dataset.firmness || '').toLowerCase());
      }

      // Tags — must contain at least one selected (OR) per group
      if (state.tags && state.tags.size) {
        var tags = (card.dataset.tags || '').toLowerCase().split(',').map(function (t) { return t.trim(); });
        var anyMatch = false;
        state.tags.forEach(function (val) {
          if (tags.indexOf(val) !== -1) anyMatch = true;
        });
        ok = ok && anyMatch;
      }

      // Price range
      if (state.priceLow !== null || state.priceHigh !== null) {
        var price = parseFloat(card.dataset.price || 0);
        if (state.priceLow !== null && price < state.priceLow) ok = false;
        if (state.priceHigh !== null && price > state.priceHigh) ok = false;
      }

      // Size — Shopify product doesn't have a single size; this filter is conceptual.
      // Treat size like tags: if a size is checked, require the product's tags to include the size string.
      if (state.size && state.size.size) {
        var sizeTags = (card.dataset.tags || '').toLowerCase().split(',').map(function (t) { return t.trim(); });
        var sizeMatch = false;
        state.size.forEach(function (val) {
          if (sizeTags.indexOf(val) !== -1) sizeMatch = true;
        });
        if (!sizeMatch) ok = false;
      }

      card.classList.toggle('is-hidden', !ok);
      if (ok) visible += 1;
    });

    if (countEl) countEl.textContent = visible;
    if (emptyEl) emptyEl.style.display = visible === 0 ? '' : 'none';
    renderChips();
    applySort();
  }

  function applySort() {
    if (!sortEl || !grid) return;
    var mode = sortEl.value;
    var sorted = cards.slice().sort(function (a, b) {
      var aP = parseFloat(a.dataset.price || 0);
      var bP = parseFloat(b.dataset.price || 0);
      switch (mode) {
        case 'price-asc': return aP - bP;
        case 'price-desc': return bP - aP;
        default: return 0;
      }
    });
    sorted.forEach(function (card) { grid.appendChild(card); });
  }

  function renderChips() {
    if (!chipsEl) return;
    chipsEl.innerHTML = '';
    Object.keys(state).forEach(function (key) {
      if (key === 'priceLow' || key === 'priceHigh') return;
      if (!state[key] || !state[key].size) return;
      state[key].forEach(function (val) {
        var chip = document.createElement('span');
        chip.className = 'chip';
        chip.innerHTML = val + ' <button type="button" aria-label="Remove">×</button>';
        chip.querySelector('button').addEventListener('click', function () {
          state[key].delete(val);
          var cb = section.querySelector('[data-plp-filter="' + key + '"][value="' + val + '"]');
          if (cb) cb.checked = false;
          applyFilters();
        });
        chipsEl.appendChild(chip);
      });
    });
  }

  // Checkbox changes
  section.querySelectorAll('[data-plp-filter]').forEach(function (cb) {
    cb.addEventListener('change', function () {
      var key = cb.dataset.plpFilter;
      var val = cb.value;
      state[key] = state[key] || new Set();
      if (cb.checked) state[key].add(val); else state[key].delete(val);
      applyFilters();
    });
  });

  // Clear all
  section.querySelectorAll('[data-plp-clear]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      section.querySelectorAll('[data-plp-filter]').forEach(function (cb) { cb.checked = false; });
      Object.keys(state).forEach(function (k) {
        if (state[k] instanceof Set) state[k].clear();
      });
      state.priceLow = null;
      state.priceHigh = null;
      // Reset price sliders
      var rangeLow = section.querySelector('.plp-range--low');
      var rangeHigh = section.querySelector('.plp-range--high');
      if (rangeLow) rangeLow.value = rangeLow.min;
      if (rangeHigh) rangeHigh.value = rangeHigh.max;
      paintRange();
      applyFilters();
    });
  });

  // Sort
  if (sortEl) sortEl.addEventListener('change', applySort);

  // View toggle
  section.querySelectorAll('[data-plp-view]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      section.querySelectorAll('[data-plp-view]').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      if (grid) grid.setAttribute('data-view', btn.dataset.plpView);
    });
  });

  // Price slider
  var sliderWrap = section.querySelector('.plp-price-slider');
  var rangeLow = section.querySelector('.plp-range--low');
  var rangeHigh = section.querySelector('.plp-range--high');
  var fill = section.querySelector('.plp-range-fill');
  var minLabel = section.querySelector('[data-plp-price-min-label]');
  var maxLabel = section.querySelector('[data-plp-price-max-label]');

  function paintRange() {
    if (!rangeLow || !rangeHigh || !sliderWrap) return;
    var min = Number(rangeLow.min);
    var max = Number(rangeLow.max);
    var lo = Number(rangeLow.value);
    var hi = Number(rangeHigh.value);
    if (hi - lo < 50) {
      if (event && event.target === rangeLow) lo = hi - 50;
      else hi = lo + 50;
      rangeLow.value = lo;
      rangeHigh.value = hi;
    }
    var loPct = ((lo - min) / (max - min)) * 100;
    var hiPct = ((hi - min) / (max - min)) * 100;
    if (fill) {
      fill.style.left = loPct + '%';
      fill.style.right = (100 - hiPct) + '%';
    }
    if (minLabel) minLabel.textContent = '$' + lo;
    if (maxLabel) maxLabel.textContent = '$' + hi;
    state.priceLow = lo;
    state.priceHigh = hi;
  }
  if (rangeLow) rangeLow.addEventListener('input', function () { paintRange(); applyFilters(); });
  if (rangeHigh) rangeHigh.addEventListener('input', function () { paintRange(); applyFilters(); });
  paintRange();
});

// Cert strip: inject left/right arrow buttons over the horizontal scroll row
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.cert-strip-compact').forEach(function (section) {
    var row = section.querySelector('.row');
    var itemWrap = section.querySelector('.item-wrap');
    if (!row || !itemWrap) return;

    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'cert-arrow cert-arrow--prev';
    prevBtn.setAttribute('aria-label', 'Previous certifications');
    prevBtn.innerHTML = '‹';

    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'cert-arrow cert-arrow--next';
    nextBtn.setAttribute('aria-label', 'Next certifications');
    nextBtn.innerHTML = '›';

    row.appendChild(prevBtn);
    row.appendChild(nextBtn);

    var firstItem = itemWrap.querySelector('.item');
    var scrollStep = firstItem ? firstItem.offsetWidth + 24 : 200;

    prevBtn.addEventListener('click', function () {
      itemWrap.scrollBy({ left: -scrollStep * 2, behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      itemWrap.scrollBy({ left: scrollStep * 2, behavior: 'smooth' });
    });

    function updateArrowState() {
      var atStart = itemWrap.scrollLeft <= 0;
      var atEnd = itemWrap.scrollLeft + itemWrap.clientWidth >= itemWrap.scrollWidth - 1;
      prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    }

    itemWrap.addEventListener('scroll', updateArrowState);
    window.addEventListener('resize', updateArrowState);
    updateArrowState();
  });
});

/* ============================================================
   HOME LINEUP CAROUSEL — arrow navigation for the mattress rail.
   Scrolls the track by ~1 card width per click and updates the
   disabled state on the arrows when at the start/end.
   ============================================================ */
(function () {
  function initLineupRail(rail) {
    var track = rail.querySelector('.lineup-track');
    var prev  = rail.querySelector('.lineup-arrow--prev');
    var next  = rail.querySelector('.lineup-arrow--next');
    if (!track || !prev || !next) return;

    function cardStep() {
      var firstCard = track.querySelector('.product-card');
      if (!firstCard) return 320;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      return firstCard.getBoundingClientRect().width + gap;
    }
    function updateArrows() {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll;
    }
    prev.addEventListener('click', function () {
      track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left:  cardStep(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();

    // Initial position: land on card 2 so the leftmost visible card is Pure,
    // not Youth. Youth (card 1) sits off-screen left, reachable via the prev
    // arrow. Per client direction — Pure anchors the adult lineup, Youth is
    // the entry-tier discoverable to the left.
    function setInitialOffset() {
      if (track.scrollWidth <= track.clientWidth) return;
      track.scrollLeft = cardStep();
      updateArrows();
    }
    // Defer one frame so card widths are measured after layout settles.
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(setInitialOffset);
    } else {
      setInitialOffset();
    }
  }

  function bootLineup() {
    document.querySelectorAll('.section-home-lineup .lineup-rail').forEach(initLineupRail);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootLineup);
  } else {
    bootLineup();
  }
})();

/* ============================================================
   Cert strip marquee — duplicate items so the CSS animation
   (translateX 0 -> -50%) loops seamlessly. Idempotent: marks the
   wrap with data-marquee-init so reruns (e.g. via theme editor
   section reload) don't double-duplicate.
   ============================================================ */
(function () {
  function initCertMarquee(wrap) {
    if (wrap.dataset.marqueeInit === '1') return;
    var items = Array.prototype.slice.call(wrap.children);
    if (items.length === 0) return;
    // Clone each item once, marking clones aria-hidden so screen
    // readers don't read the certs twice.
    items.forEach(function (node) {
      var clone = node.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      wrap.appendChild(clone);
    });
    wrap.dataset.marqueeInit = '1';
  }
  function bootCertMarquee() {
    document.querySelectorAll('.cert-strip-compact .item-wrap').forEach(initCertMarquee);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootCertMarquee);
  } else {
    bootCertMarquee();
  }
  // Re-init when Shopify section editor reloads the section
  document.addEventListener('shopify:section:load', bootCertMarquee);
})();

jQuery(function($){
    $( document ).ready(function(){
        $('.certified-slider .item-wrap').slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            autoplay: false,
            autoplaySpeed: 3000,
            pauseOnHover: false,
            variableWidth: true,
			nextArrow: '<button class="cstm-next" aria-label="Next" type="button"><img src="https://cdn.shopify.com/s/files/1/0702/7543/2741/files/arrow_next.png?v=1698400857" alt=""></button>',
			prevArrow: '<button class="cstm-prev" aria-label="Previous" type="button"><img src="https://cdn.shopify.com/s/files/1/0702/7543/2741/files/arrow_prev.png?v=1698400857" alt=""></button>',
			responsive: [
				{
				  breakpoint: 1024,
				  settings: {
					slidesToShow: 4,
				  },
				},
                {
				  breakpoint: 767,
				  settings: {
					slidesToShow: 2,
				  },
				}
			]
        });
    });
});

// ============================================
// CART DRAWER — discount code apply + drawer refresh after upsell add
// ============================================
(function () {
  "use strict";

  function refreshCartDrawer() {
    return fetch(EvayaRoutes.section("cart-drawer"), { credentials: "same-origin" })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        var fresh = doc.querySelector("#Cart-Drawer .side-panel-inner");
        var current = document.querySelector("#Cart-Drawer .side-panel-inner");
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
        }
      })
      .catch(function (e) { console.error("Cart drawer refresh failed", e); });
  }

  window.evayaRefreshCartDrawer = refreshCartDrawer;

  document.addEventListener("submit", function (e) {
    var form = e.target.closest("[data-cart-discount]");
    if (!form) return;
    e.preventDefault();

    var input = form.querySelector("input[name=\"discount\"]");
    var btn = form.querySelector(".apply-btn");
    if (!input) return;

    var code = (input.value || "").trim();
    var path = EvayaRoutes.discount(code.length > 0 ? code : null);

    if (btn) btn.textContent = "Applying…";

    // If the form is on the cart page, reload the page (refreshes totals + applied-state).
    // If it's in the drawer, refresh just the drawer section.
    var onCartPage = !!form.closest(".evaya-cart-page");

    fetch(path, { credentials: "same-origin", redirect: "manual" })
      .catch(function () {})
      .finally(function () {
        if (onCartPage) {
          window.location.reload();
        } else {
          refreshCartDrawer();
        }
      });
  });

  document.addEventListener("submit", function (e) {
    var form = e.target.closest(".evaya-cart-drawer .upsell-row");
    if (!form) return;
    e.preventDefault();

    var data = new FormData(form);
    fetch(EvayaRoutes.cartAddJs(), {
      method: "POST",
      credentials: "same-origin",
      body: data
    })
      .then(function (r) { return r.json(); })
      .then(function () { refreshCartDrawer(); })
      .catch(function (err) { console.error("Upsell add failed", err); });
  });

  // Open the cart drawer programmatically — adds .active to the side-panel,
  // matching what the theme's existing toggle JS does on cart-icon click.
  function openCartDrawer() {
    var drawer = document.getElementById("Cart-Drawer");
    if (!drawer) return;
    drawer.classList.add("active");
    // Some themes also toggle a body class for scroll-lock; safe to add if present.
    document.body.classList.add("side-panel-open");
  }
  window.evayaOpenCartDrawer = openCartDrawer;

  // After Add-to-Cart on any product page form, open the drawer instead of
  // navigating to /cart. Skip if the form is the upsell-row (already handled
  // above) or the recommendations grid on the cart page (full reload makes more sense there).
  document.addEventListener("submit", function (e) {
    var form = e.target.closest("form[action$=\"/cart/add\"], form[action*=\"/cart/add?\"]");
    if (!form) return;
    if (form.closest(".evaya-cart-drawer")) return;        // drawer upsell handled above
    if (form.closest(".evaya-cart-page .ec-rec-add-form")) return; // cart page recs reload page
    e.preventDefault();

    var data = new FormData(form);
    var btn = form.querySelector("[type=\"submit\"]");
    var originalLabel = btn ? btn.innerHTML : null;
    if (btn) { btn.disabled = true; btn.innerHTML = "Adding…"; }

    fetch(EvayaRoutes.cartAddJs(), {
      method: "POST",
      credentials: "same-origin",
      headers: { "Accept": "application/javascript" },
      body: data
    })
      .then(function (r) {
        if (!r.ok) { return r.json().then(function (j) { throw new Error(j.description || "Add failed"); }); }
        return r.json();
      })
      .then(function () { return refreshCartDrawer(); })
      .then(function () { openCartDrawer(); })
      .catch(function (err) {
        console.error("Add-to-cart failed", err);
        alert(err.message || "Sorry, that couldn't be added to your cart.");
      })
      .finally(function () {
        if (btn) { btn.disabled = false; if (originalLabel) btn.innerHTML = originalLabel; }
      });
  });
})();

/* ------------------------------------------------------------------
 * CART PAGE — quantity stepper (added 2026-09-09)
 *
 * The <quantity-selector> custom element in app.min.js only writes
 * input.value and dispatches a `change` event. On the cart page nothing
 * listened for it: assets/cart.min.js targets the stock theme's DOM
 * (#Cart, #CartItem-N, .thb-cart-form), none of which this section uses,
 * and it is not loaded in layout/theme.liquid at all.
 *
 * So changing the quantity moved the number on screen and did nothing
 * else. The line price, the totals AND the cart itself stayed at the old
 * quantity — and because "Secure checkout" is a plain <a href="/checkout">
 * rather than a submit for #cart-page-form, the name="updates[]" inputs
 * never posted either. A shopper could reduce a line from two to one and
 * still be charged for two.
 *
 * This persists the change to Shopify, then re-renders .ec-cart-grid,
 * which repaints the line price, the compare-at strike, the Affirm
 * per-month line, the "You save" row, the item count, subtotal,
 * discounts and total in a single pass — no money formatting duplicated
 * in JS.
 * ------------------------------------------------------------------ */
(function () {
  var GRID = ".ec-cart-grid";
  var timers = {};
  var inFlight = 0;

  function repaintCartGrid() {
    return fetch(EvayaRoutes.cartSection("evaya-cart-page"), { credentials: "same-origin" })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, "text/html").querySelector(GRID);
        var current = document.querySelector(GRID);
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
        } else {
          // Cart emptied, or the section markup moved — a reload is always correct.
          window.location.reload();
        }
      });
  }

  function pushQuantity(key, qty) {
    var grid = document.querySelector(GRID);
    if (grid) { grid.setAttribute("data-updating", "true"); }
    inFlight++;

    fetch(EvayaRoutes.cartChangeJs(), {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (j) { throw new Error(j.description || "Could not update quantity"); });
        }
        return r.json();
      })
      .then(function () { return repaintCartGrid(); })
      .catch(function (err) {
        console.error("Cart quantity update failed", err);
        // Never leave the page showing a quantity the cart does not actually hold.
        window.location.reload();
      })
      .finally(function () {
        inFlight--;
        var g = document.querySelector(GRID);
        if (g && inFlight === 0) { g.removeAttribute("data-updating"); }
      });
  }

  document.addEventListener("change", function (e) {
    var input = (e.target && e.target.closest) ? e.target.closest("quantity-selector.cart-update .qty") : null;
    if (!input || !input.closest(".evaya-cart-page")) return;

    var host = input.closest("quantity-selector");
    var key = host && host.getAttribute("data-id");
    if (!key) return;

    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 1) { qty = 1; input.value = 1; }

    // The stepper fires one change per click, so debounce: holding + or -
    // sends one request carrying the final value rather than one per click.
    clearTimeout(timers[key]);
    timers[key] = setTimeout(function () { pushQuantity(key, qty); }, 300);
  });
})();

/* ------------------------------------------------------------------
 * ADD TO CART — capture-phase interceptor (added 2026-09-09)
 *
 * WHY THIS EXISTS
 * The EG Auto Add to Cart app embed (live since 2026-09-02) binds its own
 * bubble-phase submit listener to product forms. It calls stopPropagation,
 * posts its own /cart/add, and does NOT preventDefault — so the browser's
 * native form post went through as well. One click produced TWO units, and
 * because the native post navigated to /cart, the cart drawer stopped
 * opening. Verified live: embed on = qty 2 + navigation, embed off = qty 1
 * + drawer.
 *
 * THE FIX
 * A capture-phase listener runs before any bubble-phase listener, whoever
 * registered first. This one takes the event, kills it with
 * stopImmediatePropagation, and performs exactly one add itself.
 *
 * EG still grants the free gift, because it re-evaluates on cart change
 * rather than only on the add it intercepted. Verified live: one mattress
 * at qty 1 plus two pillows at $0.00, drawer opens, no navigation.
 *
 * NOTE: this supersedes the two bubble-phase submit handlers above (the
 * drawer upsell one and the general add-to-cart one). They are left in
 * place but can no longer fire — the event never reaches bubble phase.
 * All three of their behaviours are reproduced below.
 * ------------------------------------------------------------------ */
(function () {
  var SEL = 'form[action*="/cart/add"]';

  function refreshDrawerTwice() {
    // The gift lands a moment after our add, so repaint once more.
    if (!window.evayaRefreshCartDrawer) return Promise.resolve();
    return window.evayaRefreshCartDrawer().then(function () {
      return new Promise(function (res) {
        setTimeout(function () {
          window.evayaRefreshCartDrawer().then(res, res);
        }, 1200);
      });
    });
  }

  document.addEventListener("submit", function (e) {
    var form = (e.target && e.target.closest) ? e.target.closest(SEL) : null;
    if (!form) return;

    e.preventDefault();
    e.stopImmediatePropagation();   // <- keeps the app off this event

    var isCartPageRecs = !!form.closest(".evaya-cart-page .ec-rec-add-form");
    var btn = form.querySelector("[type=\"submit\"]");
    var originalLabel = btn ? btn.innerHTML : null;
    if (btn) { btn.disabled = true; btn.innerHTML = "Adding…"; }

    fetch(EvayaRoutes.cartAddJs(), {
      method: "POST",
      credentials: "same-origin",
      headers: { "Accept": "application/javascript" },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) { return r.json().then(function (j) { throw new Error(j.description || "Add failed"); }); }
        return r.json();
      })
      .then(function () {
        // The cart page reloads so its own totals re-render server-side.
        if (isCartPageRecs) { window.location.reload(); return; }
        return refreshDrawerTwice().then(function () {
          if (window.evayaOpenCartDrawer) window.evayaOpenCartDrawer();
        });
      })
      .catch(function (err) {
        console.error("Add-to-cart failed", err);
        alert(err.message || "Sorry, that couldn't be added to your cart.");
      })
      .finally(function () {
        if (btn) { btn.disabled = false; if (originalLabel) btn.innerHTML = originalLabel; }
      });
  }, true);   // <- capture phase. This is the whole fix.
})();

/* ------------------------------------------------------------------
 * CART PAGE — Clear cart (added 2026-09-09)
 *
 * The link is <a href="/cart?clear=1" data-cart-clear>. Shopify ignores
 * ?clear=1 and nothing in the theme listened for data-cart-clear, so it
 * reloaded /cart and the cart survived.
 * ------------------------------------------------------------------ */
(function () {
  document.addEventListener("click", function (e) {
    var link = (e.target && e.target.closest) ? e.target.closest("[data-cart-clear]") : null;
    if (!link) return;
    e.preventDefault();

    fetch(EvayaRoutes.cartClearJs(), { method: "POST", credentials: "same-origin" })
      .then(function (r) {
        if (!r.ok) throw new Error("Clear failed");
        return r.json();
      })
      .then(function () { window.location.assign(EvayaRoutes.cart()); })
      .catch(function (err) {
        console.error("Clear cart failed", err);
        window.location.assign(EvayaRoutes.cart());
      });
  });
})();
